import React, { useState } from 'react';
import styles from '../../styles/AdminPanel.module.scss';
import { avatarDisplayUrl } from '../../utils/imageUrl';
import { handleAvatarImgError } from '../../utils/defaultAvatar';

const UsersList = ({ users, onEdit, onDelete }) => {
  const [expandedUsers, setExpandedUsers] = useState({});

  const formatDate = (dateString) => {
    if (!dateString) return 'Не вказано';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Не вказано';
      return date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return 'Не вказано';
    }
  };

  const toggleUserOrders = (userId) => {
    setExpandedUsers(prev => ({
      ...prev,
      [userId]: !prev[userId]
    }));
  };

  if (!users || users.length === 0) {
    return <div className={styles.empty}>Користувачі отсутствуют</div>;
  }

  return (
    <div className={styles.list}>
      {users.map((user) => {
        const orders = user.Orders || [];
        const isExpanded = expandedUsers[user.id];
        
        // Получаем последний адрес доставки з заказов
        const lastOrder = orders.length > 0 ? orders[orders.length - 1] : null;
        const deliveryAddress = lastOrder 
          ? `${lastOrder.citi}, отделение ${lastOrder.department} (${lastOrder.carrier})`
          : 'Не вказано';

        return (
          <div key={user.id} className={styles.userCard}>
            <div className={styles.listItem}>
              <div className={styles.itemImage}>
                <img
                  src={avatarDisplayUrl(user.avatar)}
                  alt={user.name}
                  className={styles.userAvatar}
                  onError={handleAvatarImgError}
                />
              </div>
              <div className={styles.itemInfo}>
                <h3>{user.name}</h3>
                <p className={styles.userEmail}>Email: {user.email}</p>
                <p className={styles.userRole}>
                  Роль: <span className={user.role === 'ADMIN' ? styles.adminRole : styles.userRoleText}>
                    {user.role === 'ADMIN' ? 'Адмінистратор' : 'Користувач'}
                  </span>
                </p>
                <p className={styles.userDate}>Зареєстровано: {formatDate(user.createdAt)}</p>
                {lastOrder && (
                  <p className={styles.deliveryAddress}>
                    Адреса доставки: {deliveryAddress}
                  </p>
                )}
                <p className={styles.ordersCount}>
                  Замовлень: {orders.length}
                </p>
                <div className={styles.userActions}>
                  {orders.length > 0 && (
                    <button
                      className={styles.toggleOrdersButton}
                      onClick={() => toggleUserOrders(user.id)}
                    >
                      {isExpanded ? 'Приховати замовлення' : 'Показати замовлення'}
                    </button>
                  )}
                  <button
                    className={styles.editButton}
                    onClick={() => onEdit(user)}
                    title="Редагувати користувача"
                  >
                    Редагувати
                  </button>
                  <button
                    className={styles.deleteButton}
                    onClick={() => onDelete(user)}
                    title="Видалити користувача"
                  >
                    Видалити
                  </button>
                </div>
              </div>
            </div>

            {isExpanded && orders.length > 0 && (
              <div className={styles.ordersList}>
                <h4 className={styles.ordersTitle}>Замовлення користувача:</h4>
                {orders.map((order) => (
                  <div key={order.id} className={styles.orderItem}>
                    <div className={styles.orderHeader}>
                      <span className={styles.orderId}>Замовлення #{order.id}</span>
                      <span className={styles.orderDate}>{formatDate(order.createdAt)}</span>
                      <span className={styles.orderTotal}>{order.total}₴</span>
                    </div>
                    <div className={styles.orderDetails}>
                      <p><strong>Адреса доставки:</strong> {order.citi}, отделение {order.department}</p>
                      <p><strong>Перевізник:</strong> {order.carrier}</p>
                      <p><strong>Оплата:</strong> {order.payment}</p>
                      <p><strong>Телефон:</strong> {order.telephone}</p>
                      <div className={styles.orderItems}>
                        <strong>Товари:</strong>
                        {order.items && order.items.map((item, index) => (
                          <div key={index} className={styles.orderItemProduct}>
                            {item.title} - {item.quantity} шт. × {item.price}₴ = {item.quantity * item.price}₴
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default UsersList;

